<template>
  <div class="table-responsive">
    <table class="table table-hover client-users-table mb-0">
      <thead>
        <tr>
          <th>Naam</th>
          <th>E-mailadres</th>
          <th>Telefoonnummer</th>
          <th>Status</th>
          <th>Laatst ingelogd</th>
          <th class="text-right">Acties</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="clientUser in clientUsers" :key="clientUser.id" :data-client-user="clientUser.id">
          <td>{{ clientUser.name }}</td>
          <td>{{ clientUser.email }}</td>
          <td>{{ phoneNumberOf(clientUser) }}</td>
          <td>
            <span class="badge" :class="statusBadge(clientUser)">{{ statusLabel(clientUser) }}</span>
          </td>
          <td>{{ formatLastLogin(clientUser) }}</td>
          <td class="text-right">
            <button
                v-if="!readOnly && canBeReinvited(clientUser)"
                type="button"
                class="btn btn-sm btn-outline-primary ml-1 mb-1 resend-invitation"
                :disabled="busy"
                @click="$emit('resendInvitation', clientUser)"
            >
              <i class="fal fa-paper-plane mr-1"></i> Opnieuw versturen
            </button>
            <button
                v-if="!readOnly && canBeDeactivated(clientUser)"
                type="button"
                class="btn btn-sm btn-outline-danger ml-1 mb-1 deactivate"
                :disabled="busy"
                @click="$emit('deactivate', clientUser)"
            >
              <i class="fal fa-user-slash mr-1"></i> Deactiveren
            </button>
            <button
                v-if="!readOnly && canBeReactivated(clientUser)"
                type="button"
                class="btn btn-sm btn-outline-success ml-1 mb-1 reactivate"
                :disabled="busy"
                @click="$emit('reactivate', clientUser)"
            >
              <i class="fal fa-user-check mr-1"></i> Heractiveren
            </button>
            <small v-if="pointsToForgottenPassword(clientUser)" class="d-block text-muted forgotten-password-hint">
              {{ forgottenPasswordHint }}
            </small>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  canBeDeactivated,
  canBeReactivated,
  canBeReinvited,
  FORGOTTEN_PASSWORD_HINT,
  formatLastLogin,
  phoneNumberOf,
  pointsToForgottenPassword,
  statusBadge,
  statusLabel,
} from '@/utils/clientUserOverview';

export default {
  props: {
    clientUsers: {type: Array, required: true},
    busy: {type: Boolean, default: false},
    readOnly: {type: Boolean, default: false},
  },
  data() {
    return {
      forgottenPasswordHint: FORGOTTEN_PASSWORD_HINT,
    };
  },
  methods: {
    canBeDeactivated,
    canBeReactivated,
    canBeReinvited,
    formatLastLogin,
    phoneNumberOf,
    pointsToForgottenPassword,
    statusBadge,
    statusLabel,
  },
};
</script>

<style scoped>
.client-users-table td {
  vertical-align: middle;
}

.forgotten-password-hint {
  white-space: normal;
}
</style>
